module.exports = {
  promoOfferComponentEvents: {
    promoOfferDialog: {
      code: 'ContextualLogin',
      events: {
        PageLoaded: {
          description: 'Triggers when the contextual login popup loads.',
          eventHub: {
            code: 'PopupLoad',
            action: 'Contextual_Login_Page_Loaded-[$.campaign]',
            dataKeys: ['campaign']
          },
          ga: {
            action: 'Contextual_Login_Page_Loaded-[$.campaign]'
          }
        },
        CtaClicked: {
          description: 'Triggers when a user clicks the CTA on the contextual login popup.',
          eventHub: {
            code: 'CtaClick',
            action: 'Contextual_Login_Cta_Clicked-[$.campaign]',
            dataKeys: ['service']
          },
          ga: {
            action: 'Contextual_Login_Cta_Clicked-[$.campaign]'
          }
        },
        CloseClicked: {
          description: 'Triggers when a user closed the contextual login popup.',
          eventHub: {
            code: 'PopupClose',
            action: 'Contextual_Login_Close_Clicked-[$.campaign]',
            dataKeys: ['service']
          },
          ga: {
            action: 'Contextual_Login_Close_Clicked-[$.campaign]'
          }
        }
      }
    }
  }
};
